/** Статус кабинета (Account.status) – НЕ статус лицензии, макет их путал. */
export const STATUS_TONE: Record<string, 'good' | 'warn' | 'crit' | 'neutral' | 'info'> = {
  active: 'good',
  demo: 'info',
  disable: 'crit',
};

export const STATUS_LABEL: Record<string, string> = {
  active: 'Активен',
  demo: 'Демо',
  disable: 'Отключён',
};

export const TARIFF_LABEL: Record<string, string> = {
  license: 'Лицензии',
  ue: 'Условные единицы',
};

/** Account.type (CustomerEditLayout: external/internal). */
export const TYPE_LABEL: Record<string, string> = {
  external: 'Внешний',
  internal: 'Внутренний',
};

export function initials(name: string | null): string {
  if (!name) return '–';
  // Первая буква каждого слова, а не первый символ – у названий вида
  // `ООО «Нордвинд Логистика»` иначе в аватарку попадала кавычка «.
  const letters = name
    .split(/\s+/)
    .map((w) => w.match(/\p{L}/u)?.[0])
    .filter((c): c is string => Boolean(c));
  return letters.slice(0, 2).join('').toUpperCase() || '–';
}

/** Дата с названием месяца («15 июля 2026»), а не числом («15.07.2026»), без «г.». */
export function formatDate(value: string | null): string {
  if (!value) return '–';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d
    .toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })
    .replace(/\s*г\.$/, '');
}

export function formatBalance(balance: number): string {
  return `${balance.toLocaleString('ru-RU')} у.е.`;
}

/** То же, что formatDate(), плюс время – для «Истории изменений», где важно не только «когда», но и «во сколько». */
export function formatDateTime(value: string | null): string {
  if (!value) return '–';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  const time = d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  return `${formatDate(value)}, ${time}`;
}

/**
 * Дата отключения при смене статуса — 1:1 формулы Account::setActiveValidity()/
 * setDemoValidity()/setDisabledValidity() (см. докблок CustomerController::update()
 * в Laravel): активен → +3 года, демо → +2 недели, отключён → сегодня. Считаем
 * сразу на клиенте (в Orchid это асинхронный запрос-предпросмотр) – поле
 * остаётся редактируемым дальше, это просто стартовое значение. Используется и
 * в редактировании (ClientDetailPage), и в мастере создания (ClientCreatePage).
 */
export function autoValidityForStatus(status: string): string {
  const d = new Date();
  if (status === 'active') d.setFullYear(d.getFullYear() + 3);
  else if (status === 'demo') d.setDate(d.getDate() + 14);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
